import { Helmet } from "react-helmet";
import {
    Box,
    MenuItem,
    Divider,
    InputAdornment,
    TextField,
    Select,
    Container,
    Grid,
    Typography,
    Button,
    usePagination,
    Avatar,
    Paper
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect, useMemo } from "react";
import competencyService from "../../services/competency.service";
import cssVariables from "../../theme/cssVariables";
import { styled } from "@mui/styles";
import { ReactComponent as PlusIcon } from "../../icons/plus.svg";
import { ReactComponent as ChevronExpandDown } from "../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { ReactComponent as FilterStatus } from "../../assets/icons/filter-status.svg";
import { ReactComponent as Nodata } from "../../assets/icons/nodata.svg";
import * as Util from "../../services/global.service";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { listEvaluateType, listCycle } from "../../actions/admin";
import { useSelector, useDispatch } from "react-redux";
import proxyService from "../../services/proxy.service";

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();

    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}

const useStyles = makeStyles({
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    toggleBtnRoot: {
        background: `transparent !important`,
        color: "#6B6B6B !important",
        width: "320px",
        border: "none !important",
    },
    toggleBtnSelected: {
        background: `${cssVariables.color.primary}!important`,
        color: "#fff!important",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        "
    },
    tab: {
        fontSize: "16px !important",
        fontWeight: "300 !important",
        // color: "#A3A3A3 !important",
        '&.Mui-selected': {
            color: cssVariables.color.primary + " !important"
        }
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap'
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const ProxyHistory = () => {
    const [itemsProgress, setItemsProgress] = React.useState([]);
    const [mainItemsProgress, setMainItemsProgress] = React.useState([]);
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [searchProgress, setSearchValueProgress] = React.useState("");
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const proxy = JSON.parse(localStorage.getItem("proxy"));
    useEffect(() => {
        getProxy();
    }, []);

    let getProxy = () => {
        proxyService.proxyHistory().then(
            (response) => {
                setMainItemsProgress(response?.data?.proxy_history !== undefined ? response?.data?.proxy_history : []);
                setItemsProgress(response?.data?.proxy_history !== undefined ? response?.data?.proxy_history : []);
            });
    }
    const handleSearchProgress = (event) => {
        setSearchValueProgress(event.target.value);
    };

    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return itemsProgress
            .slice(firstPageIndex, lastPageIndex);
    }, [itemsProgress, currentPage, perPage]);
    const handleTotalPage = () => {
        const List = itemsProgress
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    useEffect(() => {
        handleTotalPage();
    }, [itemsProgress]);

    useEffect(() => {
        let update = checkResired
        if (Object.keys(checkResired)[0] !== undefined) {
            if (update[Object.keys(checkResired)[0]] === false) {
                currentData.sort(function (b, a) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            } else if (update[Object.keys(checkResired)[0]] === true) {
                currentData.sort(function (a, b) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setreSet(!reSet)
            }
        }
    }, [currentData]);

    useEffect(() => {
        dataSerachsProgress()
    }, [searchProgress]);
    useEffect(() => {
    }, []);

    const dataSerachsProgress = async (data) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data !== undefined && data !== null ? data : mainItemsProgress))
        if (searchProgress !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'activity' || key === 'page') {
                        return rs[key].toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1;
                    }
                    if (key === 'proxy_by') {
                        let checkName = false;
                        if (rs[key].fullname !== undefined && rs[key].fullname.toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        if (rs[key]?.options?.name_en !== undefined && rs[key]?.options?.name_en.toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        if (rs[key]?.options?.name_th !== undefined && rs[key]?.options?.name_th.toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        return checkName;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        console.log(result);
        setItemsProgress(result);
    };

    const clickLink = (data) => {
        navigate(data, { replace: false });
    }

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const toTimestamp = (strDate) => {
        if (strDate !== "" && strDate !== null && strDate !== undefined) {
            const dt = Date.parse(strDate);
            return dt / 1000;
        } else {
            return 0;
        }
    }
    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            if (key === "date") {
                currentData.sort(function (b, a) {
                    if (toTimestamp(a[key]) > toTimestamp(b[key])) {
                        return -1;
                    }
                    if (toTimestamp(b[key]) > toTimestamp(a[key])) {
                        return 1;
                    }
                    return 0;
                });
            } else if (key === "proxy_by") {
                currentData.sort(function (b, a) {
                    if (a[key].fullname > b[key].fullname) {
                        return -1;
                    }
                    if (b[key].fullname > a[key].fullname) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                currentData.sort(function (b, a) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });
            }
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            if (key === "date") {
                currentData.sort(function (a, b) {
                    if (toTimestamp(a[key]) > toTimestamp(b[key])) {
                        return -1;
                    }
                    if (toTimestamp(b[key]) > toTimestamp(a[key])) {
                        return 1;
                    }
                    return 0;
                });
            } else if (key === "proxy_by") {
                currentData.sort(function (a, b) {
                    if (a[key].fullname > b[key].fullname) {
                        return -1;
                    }
                    if (b[key].fullname > a[key].fullname) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                currentData.sort(function (a, b) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });
            }
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));

    if (proxy !== undefined &&  proxy !== null ) {
        navigate('/kpi/home', { replace: false });
    }

return (
    <Box style={{ "max-height": "100%", "overflow-y": "auto" }}>
        <Helmet>
            <title>HOME | PMS </title>
        </Helmet>
        <Box
            sx={{
                backgroundColor: 'background.default',
                minHeight: '100%',
                py: 3
            }}
        >
            <Container maxWidth="xl">
                <Grid container pt={2} pb={2}>
                    <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.end} >{t('proxy.proxyHistory')}</span></Typography>
                </Grid>
                <Grid container item >
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px" pb="30px">
                        <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                            {t('proxy.proxyHistory')}
                        </Typography>
                        <TextField
                            id="input-with-icon-textfield"
                            fullWidth
                            placeholder={t('label.search')}
                            size="small"
                            sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" } }}
                            className="searchTextField-h40"
                            value={searchProgress}
                            onChange={handleSearchProgress}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search style={{ color: "#C4C4C4" }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                </Grid>
                <Grid container spacing={2}>
                    <Grid container item >
                        <div className={classes.root}>
                            <Paper className={classes.flexPaper} >
                                <Box
                                    px="40px"
                                >
                                    <Box
                                        px="25px"
                                        py="19px"
                                        sx={{ display: "flex", "flex-direction": "row" }}
                                    >
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "130px" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('label.date')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("date", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("date", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(34.02% - 43.33px)" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('proxy.activity')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("activity", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("activity", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(22.75% - 43.33px)" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('label.page')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("page", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("page", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(43.23% - 43.34px)" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('proxy.proxyBy')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("proxy_by", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("proxy_by", false)} />
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Divider width="100%" />
                                </Box>
                                {currentData !== undefined && currentData !== null && currentData.length > 0 ? currentData.map((row, index) => (
                                    <Box px="40px">
                                        <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                            <Box
                                                sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex" }}
                                                px="25px" py="22px"
                                            >
                                                <Box sx={{ display: "flex", "flex-direction": "column", width: "130px" }} pr="15px" pt="3px">
                                                    <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {Util.dateDayFormatAdmin(row?.date)}
                                                    </Typography>
                                                    <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {Util.timeFormat(row?.date)}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "calc(34.02% - 43.33px)" }} pr="15px" pt="3px">
                                                    <Typography fontSize={16} lineHeight="24px" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {`${row?.activity}`}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "calc(22.75% - 43.33px)" }} pr="15px" pt="3px">
                                                    <Typography fontSize={16} lineHeight="24px" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {`${row?.page}`}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "calc(43.23% - 43.34px)", display: "flex", justifyContent: "flex-start" }} >
                                                    <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }} >
                                                        <Avatar
                                                            src={Util.formatData(row?.proxy_by?.photo, "")}
                                                            sx={{
                                                                cursor: "pointer",
                                                                width: 40,
                                                                height: 40,
                                                            }}
                                                        />
                                                    </Box>
                                                    <Box pl="15px" sx={{ width: "calc(100% - 40px)" }}>
                                                        <Typography fontWeight="500" fontSize={18} lineHeight="26.91px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {Util.formatData(row?.proxy_by?.fullname, "")}
                                                        </Typography>
                                                        <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.proxy_by?.position} {row?.proxy_by?.organization !== undefined && row?.proxy_by?.organization !== "" ? `(${row?.proxy_by?.organization})` : " "}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Divider width="100%" />
                                    </Box>
                                ))
                                    :
                                    <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "500px" }}>
                                        <Nodata />
                                        <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                            {t('label.noDataFilter')}
                                        </Typography>
                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                            {t('label.tryChangingFilter')}
                                        </Typography>
                                    </Box>
                                }
                            </Paper>
                        </div>
                    </Grid>
                </Grid>
                <Grid container mt={1} spacing={2} >
                    <Grid item xs sm md display="flex" alignItems="center">
                        <Box mr={1}>
                            <Typography variant="s14_fw400">{t('label.showMaxItems')}</Typography>
                        </Box>
                        <Select
                            id="pagination"
                            variant="outlined"
                            defaultValue={10}
                            value={perPage}
                            onChange={handlePerPageChange}
                            displayEmpty
                            size="small"
                            className="white-bg"
                        >
                            <MenuItem value={10}>
                                <Typography style={{ fontWeight: "300" }}>10</Typography>
                            </MenuItem>
                            <MenuItem value={20}>
                                <Typography style={{ fontWeight: "300" }}>20</Typography>
                            </MenuItem>
                            <MenuItem value={30}>
                                <Typography style={{ fontWeight: "300" }}>30</Typography>
                            </MenuItem>
                        </Select>
                    </Grid>
                    <Grid item display="flex" alignItems="center" ml="auto">
                        <Typography variant="s14_fw400">
                            {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                        </Typography>
                    </Grid>
                    <Grid item ml="auto" display="flex" alignItems="center">
                        <CustomPagination
                            setCurrentPage={handleSetCurrentPage}
                            selected={currentPage}
                            count={totalPage}
                        ></CustomPagination>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    </Box>
);
};
export default ProxyHistory;
